<template>
    <div class="modal-wrapper" v-if="visible">
        <h2>{{ title }}</h2>
        <p>{{ text }}</p>
        <div class="modal-buttons">
            <button @click="hide" class="modal-button">Close</button>
            <button @click="confirm" class="modal-button">Confirm</button>
        </div>
    </div>
</template>

<script>
    import AlertModal from '../plugins/alertModal';

    export default {
        data() {
            return {
                // variable that shows/hides modal
                visible: false,
                title: '',
                text: '',
                // adding callback function variable
                onConfirm: {}
            }
        },
        methods: {
            hide() {
                // this method is unchanged
            },
            confirm() {
                // we must check if this.onConfirm is function
                if (typeof this.onConfirm === 'function') {
                    // run passed function and then close the modal
                    this.onConfirm();
                    this.hide();
                } else {
                    // we only close the modal
                    this.hide();
                }
            },
            show(params) {
                // making modal visible
                this.visible = true;
                // setting title and text
                this.title = params.title;
                this.text = params.text;
                // setting callback function
                this.onConfirm = params.onConfirm;
            }
        },
        beforeMount() {
            // here we need to listen for emited events
            // we declared those events inside our plugin
            AlertModal.EventBus.$on('show', (params) => {
                this.show(params)
            })
        }
    }
</script>

<style scoped>
    .modal-wrapper {
        position: fixed;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 300px;
        height: 200px;
        z-index: 1000;
        border-radius: 2px;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
    }

    .modal-buttons {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        display: flex;
    }

    .modal-button {
        flex-grow: 1;
    }
</style>
